<calao-form [readOnly]="isReadOnly" [model]="model" [customSubmit]="customSubmit" [formDescriptorId]="formDescriptorId"
	[formDefinitionId]="formDefinitionId"></calao-form>